import { useParams } from "react-router-dom";
import {
  UpdatedeleteOneInvoice,
  getSingleIdInvoice,
  updateInvoiceList,
} from "../../../redux/invoice/action";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { getUserList } from "../../../redux/invoice/action";
import { addInvoicesValidation } from "../../Constant/constant";
import professional from "../../assets/images/professional.png";
import { clientsDataList } from "../../../redux/user/action";
import { Modal } from "reactstrap";
import AddClient from "../User/AddClient";


const UpdateInvoices = () => {
  const { id } = useParams();
  const [modal, setModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const singleInvoice = useSelector(
    (state) => state?.reusableSlice?.singleInvoice
  );

  const invoiceDownloadURL = singleInvoice?.invoice;
  const userList = useSelector((state) => state?.reusableSlice?.userList);
  const [selectedClient, setSelectedClient] = useState({
    value: "",
    label: "",
  });

  const [selectedOptions, setSelectedOptions] = useState({
    value: "",
    label: "",
  });

  // Initialize states
  const [selectdurationtype, setselectdurationtype] = useState("");
  const [selectDate, setSelectDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [params, setParams] = useState({
    search_key: "",
    // page: 1
  });
  const [param, setParam] = useState({
    parent_id: selectedOptions?.value,
  });

  useEffect(() => {
    setParam((prevState) => ({
      ...prevState,
      parent_id: selectedOptions?.value,
    }));
  }, [selectedOptions]);
  const [logoUrl, setLogoUrl] = useState();
  const [logoFile, setLogoFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Update the invoiceDetails state initialization
  const [invoiceDetails, setInvoiceDetails] = useState([]);

  const clientsData = useSelector(
    (state) => state?.reusableSlice?.getClientData
  );

  useEffect(() => {
    dispatch(clientsDataList(param));
  }, [dispatch, param]);

  const proClientOptions = clientsData?.users?.map((item) => ({
    value: item?.id,
    label: item?.full_name,
  }));

  useEffect(() => {
    if (singleInvoice?.invoice_details?.length > 0) {
      setInvoiceDetails(singleInvoice.invoice_details);
    } else {
      setInvoiceDetails([
        {
          description: "",
          unit_price: 0,
          quantity: 1,
          vat_percent: 0,
          discount_percent: 0,
          product_id: "",
          id: null,
          invoice_id: null,
        },
      ]);
    }
  }, [singleInvoice]);

  useEffect(() => {
    if (singleInvoice) {
      setselectdurationtype(String(singleInvoice.invoice_type || ""));
      setSelectDate(singleInvoice.date_time?.split(" ")[0] || "");
      setStartTime(singleInvoice.date_time?.split(" ")[1]?.slice(0, 5) || "");
      const user = userList?.users?.find(
        (user) => user.id === singleInvoice.user_id
      );
      setSelectedOptions({
        value: singleInvoice.user_id || "",
        label: user?.company_name || "",
      });
    }
  }, [singleInvoice, userList]);

  useEffect(() => {
    if (singleInvoice) {
      setselectdurationtype(String(singleInvoice.invoice_type || ""));
      setSelectDate(singleInvoice.date_time?.split(" ")[0] || "");
      setStartTime(singleInvoice.date_time?.split(" ")[1]?.slice(0, 5) || "");

      // Update selected user
      const clients = clientsData?.users?.find(
        (client) => client?.id === singleInvoice?.client_id
      );
      setSelectedClient({
        value: clients?.id || "",
        label: clients?.full_name || "",
      });
    }
  }, [singleInvoice, clientsData]);

  useEffect(() => {
    if (id) {
      dispatch(getSingleIdInvoice(id));
    }
  }, [id]);

  useEffect(() => {
    console.log("Single Invoice Data:", singleInvoice);
    console.log("Invoice Details:", singleInvoice?.invoice_details);
  }, [singleInvoice]);

  const handleAddInvoiceDetail = () => {
    const newDetail = {
      description: "",
      unit_price: "",
      quantity: 1,
      vat_percent: "",
      discount_percent: "",
      product_id: "",
      id: null,
      invoice_id: null,
    };

    setInvoiceDetails((prevDetails) => [...prevDetails, newDetail]);
    formik.setFieldValue("invoice_detail", [
      ...(formik.values.invoice_detail || []),
      newDetail,
    ]);
  };

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("user_id", selected?.value);
  };

  const handleChangeClient = (selected) => {
    setSelectedClient(selected);
    formik.setFieldValue("client_id", selected?.value);
  };

  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.full_name,
  }));

  useEffect(() => {
    dispatch(getUserList(params));
  }, [dispatch, params]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      invoice_detail: singleInvoice?.invoice_details || [
        {
          description: "",
          unit_price: "",
          quantity: 1,
          vat_percent: "",
          discount_percent: "",
          product_id: "",
          id: null,
          invoice_id: null,
        },
      ],
      user_id: singleInvoice?.user_id || "",
      client_id: singleInvoice?.client_id || "",
      //   invoice_type: Number(singleInvoice?.invoice_type) || "",
      invoice_type: Number(singleInvoice?.invoice_type) ?? "",
      reference_number: singleInvoice?.reference_number || "",
      footer_text: singleInvoice?.footer_text || "",
      notes: singleInvoice?.notes || "",
      logo: singleInvoice?.logo || "",
      date_time: singleInvoice?.date_time || "",
    },
    validationSchema: addInvoicesValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleLogoChange = async (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      setImageLoading(true);
  
    }
  };

  const handleInvoiceTypeChange = (invoiceType) => {
    setselectdurationtype(invoiceType);
    formik.setFieldValue("invoice_type", invoiceType);

    if (invoiceType === 0) {
      setSelectedClient(null);
      formik.setFieldValue("client_id", "");
    }
  };

  const handledateChange = (e) => {
    const date = e.target.value;
    setSelectDate(date);
    updateDateTime(date, startTime);
  };

  const handleStartTime = (event) => {
    const time = event.target.value;
    setStartTime(time);
    updateDateTime(selectDate, time);
  };

  const updateDateTime = (date, time) => {
    if (date && time) {
      const dateTime = `${date} ${time}:00`;
      formik.setFieldValue("date_time", dateTime);
    } else {
      formik.setFieldValue("date_time", "");
    }
  };

  const handelContryCode = (value, data) => {
    formik.setFieldValue(
      "seller_contact_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("seller_country_code", `+${data.dialCode}`);
  };

  const handleIncrement = (index) => {
    const currentValue = formik.values.invoice_detail[index].quantity || 1;
    if (currentValue < 10) {
      const updatedValue = currentValue + 1;
      formik.setFieldValue(`invoice_detail.${index}.quantity`, updatedValue);
    }
  };

  const handleDecrement = (index) => {
    const currentValue = formik.values.invoice_detail[index].quantity || 1;
    if (currentValue > 1) {
      formik.setFieldValue(
        `invoice_detail.${index}.quantity`,
        currentValue - 1
      );
    }
  };

  const handleSubmit = async (values) => {

    try {
      const dateTime =
        selectDate && startTime ? `${selectDate} ${startTime}:00` : "";

      const data = {
        ...values,
        invoice_type: Number(values.invoice_type),
        date_time: dateTime,
        id: singleInvoice?.id,
      };

      if (Number(values.invoice_type) === 0) {
        delete data.client_id;
      }

      dispatch(updateInvoiceList(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };

  const deleteOneInvoice = (detail, index) => {
    if (detail.id) {
      dispatch(UpdatedeleteOneInvoice(detail.id, setLoading, navigate));
    } else {
      setInvoiceDetails((prevDetails) =>
        prevDetails.filter((_, i) => i !== index)
      );
      formik.setFieldValue(
        "invoice_detail",
        formik.values.invoice_detail.filter((_, i) => i !== index)
      );
    }
  };

  return (
    <div className="px-3">

      <div className=" category-wrapper">
        <div className="d-flex justify-content-between align-items-cente pb-5">
          <h3 className="">Update Invoice</h3>
          <Modal isOpen={modal} toggle={() => setModal(!modal)}>
            <AddClient
              id={formik.values.user_id}
              modal={modal}
              setModal={setModal}
              params={params}
              setParams={setParams}
            />
          </Modal>
          <span
            className="background-button"
            onClick={() => {
              const link = document.createElement("a");
              link.href = invoiceDownloadURL;
              link.download = `${singleInvoice?.invoice || "invoice"}.pdf`;
              link.click();
            }}
            style={{ cursor: "pointer", textDecoration: "none" }}
          >
            <span> Download Invoice</span>
          </span>
        </div>

        <form onSubmit={formik.handleSubmit}>
          <div className="col-md-12 ">
            <div className="row">
              <div className="business-logo d-flex align-items-center col-md-12 form-group justify-content-center flex-column">
                <div className="profile-edit">
                  {imageLoading ? (
                    <div className="loader-container">
                      <i className="fa fa-spinner fa-spin loader-icon"></i>{" "}
                    </div>
                  ) : (
                    <img
                      src={formik.values.logo || professional}
                      alt="Business Logo"
                    />
                  )}
                  <label htmlFor="logo-upload" style={{ cursor: "pointer" }}>
                    <i className="fa fa-pencil"></i>
                  </label>
                </div>
                <div className="text-center">
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    id="logo-upload"
                    onChange={handleLogoChange}
                  />
                </div>
                {formik.touched.logo && formik.errors.logo ? (
                  <div className="error">{formik.errors.logo}</div>
                ) : null}
              </div>

              <div className="tab-sec col-md-12">
                <h4 className="invoice_text">Invoice Type</h4>
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a
                      className={`nav-link ${formik.values.invoice_type === 0 ? "active" : ""
                        }`}
                      onClick={() => handleInvoiceTypeChange(0)}
                    >
                      <input
                        type="radio"
                        name="invoice_type"
                        checked={formik.values.invoice_type === 0}
                        onChange={() => handleInvoiceTypeChange(0)}
                      />
                      Simplified Invoice
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${formik.values.invoice_type === 1 ? "active" : ""
                        }`}
                      onClick={() => handleInvoiceTypeChange(1)}
                    >
                      <input
                        type="radio"
                        name="invoice_type"
                        checked={formik.values.invoice_type === 1}
                        onChange={() => handleInvoiceTypeChange(1)}
                      />
                      VAT Invoice
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${formik.values.invoice_type === 2 ? "active" : ""
                        }`}
                      onClick={() => handleInvoiceTypeChange(2)}
                    >
                      <input
                        type="radio"
                        name="invoice_type"
                        checked={formik.values.invoice_type === 2}
                        onChange={() => handleInvoiceTypeChange(2)}
                      />
                      Purchase Invoice
                    </a>
                  </li>
                </ul>
                {formik.touched.invoice_type && formik.errors.invoice_type ? (
                  <div className="error">{formik.errors.invoice_type}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>Customer</label>
                <ReactSelect
                  value={selectedOptions}
                  onChange={handleChange}
                  options={proOptions}
                  placeholder="select customer"
                />
                {formik.touched.user_id && formik.errors.user_id ? (
                  <div className="error">{formik.errors.user_id}</div>
                ) : null}
              </div>

              <div className="col-md-4 form-group">
                <label>Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={selectDate}
                  onChange={handledateChange}
                />
              </div>

              {formik.values.invoice_type == 0 ? (
                ""
              ) : (
                <div className="col-md-4 form-group">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <label className="m-0">Client</label>
                    <span
                      onClick={() => setModal(!modal)}
                      className="add-client-btn"
                      style={{ width: "max-content", cursor: "pointer" }}
                    >
                      <span>Add Client</span>
                    </span>
                  </div>
                  <ReactSelect
                    value={selectedClient}
                    onChange={handleChangeClient}
                    options={proClientOptions}
                    placeholder="select user"
                  />
                  {formik.touched.client_id && formik.errors.client_id ? (
                    <div className="error">{formik.errors.client_id}</div>
                  ) : null}
                </div>
              )}

              <div className="col-md-4 form-group">
                <label>Time</label>
                <input
                  type="time"
                  className="form-control w-100"
                  placeholder="Enter start time"
                  value={startTime}
                  onChange={handleStartTime}
                />
              </div>

              {formik.touched.date_time && formik.errors.date_time ? (
                <div className="error">{formik.errors.date_time}</div>
              ) : null}

              <div className="col-md-4 form-group">
                <label>Reference Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Reference number"
                  name="reference_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.reference_number}
                />
                {formik.touched.reference_number &&
                  formik.errors.reference_number ? (
                  <div className="error">{formik.errors.reference_number}</div>
                ) : null}
              </div>

              <div className="col-md-4 form-group">
                <label>Terms & Conditions</label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter text"
                  name="footer_text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.footer_text}
                />
                {formik.touched.footer_text && formik.errors.footer_text ? (
                  <div className="error">{formik.errors.footer_text}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>Message & Notes</label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter text"
                  name="notes"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.notes}
                />
                {formik.touched.notes && formik.errors.notes ? (
                  <div className="error">{formik.errors.notes}</div>
                ) : null}
              </div>

              {formik.values.invoice_detail &&
                formik.values.invoice_detail.map((detail, index) => (
                  <div className="col-md-12  ">
                    <div className="description-add">
                      <div className="row align-items-center">
                        <React.Fragment key={index}>
                          <div className="col-md-5">
                            <div className="form-group">
                              <label>Description</label>
                              <textarea
                                style={{ height: "143px" }}
                                type="text"
                                className="form-control"
                                placeholder="Enter description"
                                name={`invoice_detail.${index}.description`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={
                                  formik.values.invoice_detail[index].description ||
                                  ""
                                }
                              />
                              {formik.touched.invoice_detail?.[index]
                                ?.description &&
                                formik.errors.invoice_detail?.[index]?.description ? (
                                <div className="error">
                                  {formik.errors.invoice_detail[index].description}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-md-6 form-group">
                                <label>Product Id</label>
                                <input
                                  type="string"
                                  className="form-control"
                                  placeholder="Enter product_id"
                                  name={`invoice_detail.${index}.product_id`}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.invoice_detail[index]
                                      .product_id || ""
                                  }
                                />
                                {formik.touched.invoice_detail?.[index]
                                  ?.product_id &&
                                  formik.errors.invoice_detail?.[index]
                                    ?.product_id ? (
                                  <div className="error">
                                    {formik.errors.invoice_detail[index].product_id}
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-md-6 form-group">
                                <label>Quantity</label>
                                <div className="input-group">
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => handleDecrement(index)}
                                  >
                                    -
                                  </button>
                                  <p
                                    style={{
                                      width: "60px",
                                      textAlign: "center",
                                      fontFamily: "Aenoik-medium",
                                      fontSize: "24px",
                                    }}
                                  >
                                    {formik.values.invoice_detail[index].quantity ||
                                      1}
                                  </p>
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => handleIncrement(index)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              {/* <div className="col-md-4 form-group">
                          <label>Unit Price</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter price"
                            name={`invoice_detail.${index}.unit_price`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={
                              formik.values.invoice_detail[index].unit_price ||
                              ""
                            }
                          />
                          {formik.touched.invoice_detail?.[index]?.unit_price &&
                          formik.errors.invoice_detail?.[index]?.unit_price ? (
                            <div className="error">
                              {formik.errors.invoice_detail[index].unit_price}
                            </div>
                          ) : null}
                        </div> */}
                              {/* <div className="col-md-4 form-group">
                          <label>Vat %</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter vat percent"
                            name={`invoice_detail.${index}.vat_percent`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={
                              formik.values.invoice_detail[index].vat_percent ||
                              ""
                            }
                          />
                          {formik.touched.invoice_detail?.[index]
                            ?.vat_percent &&
                          formik.errors.invoice_detail?.[index]?.vat_percent ? (
                            <div className="error">
                              {formik.errors.invoice_detail[index].vat_percent}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-4 form-group">
                          <label>Discount %</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter discount percent"
                            name={`invoice_detail.${index}.discount_percent`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={
                              formik.values.invoice_detail[index]
                                .discount_percent || ""
                            }
                          />
                          {formik.touched.invoice_detail?.[index]
                            ?.discount_percent &&
                          formik.errors.invoice_detail?.[index]
                            ?.discount_percent ? (
                            <div className="error">
                              {
                                formik.errors.invoice_detail[index]
                                  .discount_percent
                              }
                            </div>
                          ) : null}
                        </div> */}
                              <div className="col-md-4 form-group">
                                <label>Unit price</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter vat percent"
                                  name={`invoice_detail.${index}.unit_price`}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.invoice_detail?.[index]
                                      ?.unit_price !== undefined
                                      ? formik.values.invoice_detail?.[index]
                                        ?.unit_price
                                      : "" // fallback to "" when undefined
                                  }
                                />
                                {formik.touched.invoice_detail?.[index]
                                  ?.unit_price &&
                                  formik.errors.invoice_detail?.[index]
                                    ?.unit_price ? (
                                  <div className="error">
                                    {formik.errors.invoice_detail[index].unit_price}
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-md-4 form-group">
                                <label>Vat %</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter vat percent"
                                  name={`invoice_detail.${index}.vat_percent`}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.invoice_detail?.[index]
                                      ?.vat_percent !== undefined
                                      ? formik.values.invoice_detail?.[index]
                                        ?.vat_percent
                                      : "" // fallback to "" when undefined
                                  }
                                />
                                {formik.touched.invoice_detail?.[index]
                                  ?.vat_percent &&
                                  formik.errors.invoice_detail?.[index]
                                    ?.vat_percent ? (
                                  <div className="error">
                                    {
                                      formik.errors.invoice_detail[index]
                                        .vat_percent
                                    }
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-md-4 form-group">
                                <label>Discount %</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter discount percent"
                                  name={`invoice_detail.${index}.discount_percent`}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.invoice_detail?.[index]
                                      ?.discount_percent !== undefined
                                      ? formik.values.invoice_detail?.[index]
                                        ?.discount_percent
                                      : "" // fallback to "" when undefined
                                  }
                                />
                                {formik.touched.invoice_detail?.[index]
                                  ?.discount_percent &&
                                  formik.errors.invoice_detail?.[index]
                                    ?.discount_percent ? (
                                  <div className="error">
                                    {
                                      formik.errors.invoice_detail[index]
                                        .discount_percent
                                    }
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          {index > 0 && (
                            <div className="col-md-1">
                              <span
                                onClick={() => {
                                  deleteOneInvoice(detail, index);
                                }}
                                className="border-button"
                                style={{ padding: "   6px 10px;" }}
                              >
                                {" "}
                                <span>
                                  <i className=" fa fa-trash"></i>
                                </span>{" "}
                              </span>
                            </div>
                          )}
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                ))}
              <div className="col-md-12">
                <span
                  className="border-button d-block ml-auto"
                  onClick={handleAddInvoiceDetail}
                  style={{ cursor: "pointer", color: "blue",width:'max-content' }}
                >
                  <span>+ Add More</span>
                </span>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn  "
              onClick={() => {
                navigate("/invoices");
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Update" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateInvoices;
